
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_jswy1_189",
  "refresh": "awsui_refresh_1r9lg_jswy1_189",
  "animating": "awsui_animating_1r9lg_jswy1_203",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_jswy1_226",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_jswy1_230",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_jswy1_233",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_jswy1_236",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_jswy1_240",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_jswy1_243",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_jswy1_246",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_jswy1_249",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_jswy1_252",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_jswy1_256",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_jswy1_259",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_jswy1_262",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_jswy1_265",
  "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_1r9lg_jswy1_268",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_jswy1_271",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_jswy1_275",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_jswy1_278",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_jswy1_281",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_jswy1_284",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_jswy1_287",
  "root": "awsui_root_1r9lg_jswy1_291",
  "preferences-button": "awsui_preferences-button_1r9lg_jswy1_326",
  "close-button": "awsui_close-button_1r9lg_jswy1_330",
  "drawer-closed": "awsui_drawer-closed_1r9lg_jswy1_342",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_jswy1_347",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_jswy1_363",
  "position-bottom": "awsui_position-bottom_1r9lg_jswy1_372",
  "position-side": "awsui_position-side_1r9lg_jswy1_399",
  "slider": "awsui_slider_1r9lg_jswy1_405",
  "slider-side": "awsui_slider-side_1r9lg_jswy1_434",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_jswy1_439",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_jswy1_450",
  "open-button": "awsui_open-button_1r9lg_jswy1_461",
  "open-button-side": "awsui_open-button-side_1r9lg_jswy1_465",
  "slider-icon": "awsui_slider-icon_1r9lg_jswy1_472",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_jswy1_478",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_jswy1_481",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_jswy1_485",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_jswy1_495",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_jswy1_498",
  "content-bottom": "awsui_content-bottom_1r9lg_jswy1_506",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_jswy1_519",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_jswy1_524",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_jswy1_528",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_jswy1_532",
  "content-side": "awsui_content-side_1r9lg_jswy1_537",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_jswy1_548",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_jswy1_552",
  "header": "awsui_header_1r9lg_jswy1_557",
  "header-text": "awsui_header-text_1r9lg_jswy1_566",
  "header-actions": "awsui_header-actions_1r9lg_jswy1_577",
  "divider": "awsui_divider_1r9lg_jswy1_585"
};
  